export enum TextAreaErrorMessages {
  RequiredField = 'This is a required field.',
  NoError = ''
}
